import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getInsuranceDependentData = createAsyncThunk("api/insurance-dependent", async (token, type) => {
    try {
        const response = await nodeinstance.get("/insurance-dependent", {
            headers: { Authorization: `Bearer ${token}` },
        });
        console.log(response.data.data);
        return response.data.data;
       
    } catch (e) {
        throw new Error(e.message);
    }
});


const insuranceDependentDataSlice = createSlice({
    name: "insuranceDependent",
    initialState: {
        data: null,
        error: "",
        status: false,
        isLoading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getInsuranceDependentData.fulfilled, (state, action) => {
                state.data = action.payload;
                state.isLoading = false;
                state.status = true;
            })
            .addCase(getInsuranceDependentData.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getInsuranceDependentData.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
            });
    },
});

export { getInsuranceDependentData };
export default insuranceDependentDataSlice.reducer;
